// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__2ZQ8x","slider-nav-button":"styles-m__slider-nav-button__NZoS9","mobile-hide":"styles-m__mobile-hide__1lls8","slider-nav":"styles-m__slider-nav__10O16"};